<template>
  <section v-if="visible" id="watch-live-training" class="watch-session mb-4">
    <header class="watch-session-header">
      <div><span class="watch-session-status">{{ statusText }}</span><h3>{{ state.title || 'Training' }}</h3></div>
      <span class="watch-session-clock">{{ duration }}</span>
    </header>
    <div v-if="state.exerciseTitle && !finished" class="watch-session-current">
      <strong>{{ state.exerciseTitle }}</strong>
      <span v-if="state.setNumber">Satz {{ state.setNumber }} / {{ state.setCount }}</span>
      <span>{{ state.targetText }}</span>
      <div v-if="restSeconds > 0" class="watch-session-rest"><span>Satzpause</span><strong>{{ formatDuration(restSeconds) }}</strong></div>
    </div>
    <div v-if="state.exercises && state.exercises.length" class="watch-session-exercises">
      <div v-for="exercise in state.exercises" :key="exercise.instanceId" class="watch-session-exercise">
        <v-img v-if="exercise.imageUrl" :src="exercise.imageUrl" width="42" max-width="42" height="42" class="rounded-lg" />
        <span>{{ exercise.title }}</span><small>{{ exercise.completedSets || 0 }}/{{ exercise.setCount == null ? (exercise.sets || []).length : exercise.setCount }}</small>
      </div>
    </div>
    <v-btn v-if="!finished && link.supported" block rounded depressed color="success" class="mt-3" @click="addExercise"><v-icon left small>mdi-plus</v-icon>Übung hinzufügen</v-btn>
    <p class="watch-session-note">{{ stale ? 'Letzter Stand der Uhr – Abgleich ausstehend.' : finished ? 'Der Trainingsverlauf wird nach der Übertragung aktualisiert.' : 'Auf der Uhr gestartet · Sätze dort erfassen' }}</p>
  </section>
</template>

<script>
import trainingLiveService from "@/services/trainingLiveService"
import trainingFeatureAccess from "@/services/trainingFeatureAccess"
import watchWorkoutLink from "@/services/watchWorkoutLink"

export default {
  data: () => ({ live: trainingLiveService.viewState, link: watchWorkoutLink.view, now: Date.now(), timer: null }),
  computed: {
    state() { return this.link.state || this.live.watch || {} },
    finished() { return ["ending", "completed", "discarded"].includes(this.state.phase) },
    visible() { return !(this.$store.state.runWorkoutStore.liveSession?.clientSessionId === this.state.clientSessionId && !this.finished) && trainingFeatureAccess.isAllowed() && this.state.owner === "watch" && this.state.phase !== "discarded" && this.state.syncState !== "saved" },
    stale() { return !this.finished && this.now - this.state.updatedAt > 30000 },
    statusText() {
      if (this.finished) return "Übertragung ausstehend"
      return this.state.phase === "paused" ? "Training pausiert" : "Training läuft"
    },
    duration() {
      const running = !this.finished && this.state.phase !== "paused"
      return this.formatDuration((this.state.elapsedSeconds || 0) + (running ? Math.max(0, (this.now - this.state.elapsedAnchorAt) / 1000) : 0))
    },
    restSeconds() { return this.state.phase === "resting" ? Math.max(0, (this.state.restEndsAt - this.now) / 1000) : 0 },
  },
  mounted() { this.timer = setInterval(() => { this.now = Date.now() }, 1000) },
  beforeDestroy() { clearInterval(this.timer) },
  methods: {
    addExercise() { watchWorkoutLink.openAdd(this.state.clientSessionId) },
    formatDuration(value) { const seconds = Math.max(0, Math.floor(value || 0)); return `${Math.floor(seconds / 60)}:${String(seconds % 60).padStart(2, "0")}` },
  },
}
</script>

<style scoped>
.watch-session { border: 1px solid rgba(128,128,128,.2); border-radius: 22px; padding: 18px; background: rgba(128,128,128,.06); }
.watch-session-header { display: flex; align-items: center; justify-content: space-between; gap: 12px; }
.watch-session-header h3 { margin: 4px 0 0; font-size: 20px; overflow-wrap: anywhere; }
.watch-session-status { color: var(--v-success-base, #00963f); font-size: 12px; font-weight: 700; }
.watch-session-clock { font-variant-numeric: tabular-nums; font-size: 21px; white-space: nowrap; }
.watch-session-current { display: flex; flex-direction: column; gap: 5px; padding: 16px 0; }
.watch-session-current > strong { font-size: 18px; }
.watch-session-rest { display: flex; justify-content: space-between; align-items: center; margin-top: 8px; padding: 12px; background: rgba(0,150,63,.1); border-radius: 14px; }
.watch-session-rest strong { font-size: 30px; font-variant-numeric: tabular-nums; }
.watch-session-exercises { max-height: 280px; overflow-y: auto; }
.watch-session-exercise { display: flex; align-items: center; gap: 10px; padding: 9px 0; border-bottom: 1px solid rgba(128,128,128,.15); }
.watch-session-exercise > span { flex: 1; overflow-wrap: anywhere; }
.watch-session-exercise small { white-space: nowrap; }
.watch-session-note { opacity: .65; font-size: 12px; margin: 12px 0 0; }
</style>
